import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { ASSETS } from "../lib/assets";

export const FormsSection = () => {
  const { t } = useI18n();
  return (
    <section
      id="forms"
      data-testid="forms-section"
      className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28"
    >
      <div className="mb-12">
        <div className="section-tag">{t.forms.title}</div>
        <h2 className="font-pixel text-[#ffe600] glow-yellow text-4xl sm:text-6xl mt-2 tracking-widest">
          {t.forms.title}
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* MODULE */}
        <article
          data-testid="form-card-module"
          className="terminal-frame p-6 box-glow-cyan"
        >
          <div className="flex items-center justify-between">
            <h3 className="font-pixel text-[#00ffff] glow-cyan text-3xl tracking-widest">{t.forms.module.name}</h3>
            <span className="font-pixel text-[#94a3b8] text-base">FORM 01</span>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-3 font-mono text-xs">
            <div className="bg-black/60 border border-[#00ffff]/30 p-2">
              <div className="text-[#94a3b8]">HP</div>
              <div className="text-[#00ffff] glow-cyan">▮▮▮▮▮▮▮</div>
            </div>
            <div className="bg-black/60 border border-[#00ffff]/30 p-2">
              <div className="text-[#94a3b8]">FIRE</div>
              <div className="text-[#ffe600] glow-yellow">▮▮▮</div>
            </div>
            <div className="bg-black/60 border border-[#00ffff]/30 p-2">
              <div className="text-[#94a3b8]">SPEED</div>
              <div className="text-[#ff0044] glow-pink">▮</div>
            </div>
          </div>
          <p className="mt-5 font-mono text-[#e2e8f0]/85 text-sm sm:text-base leading-relaxed">
            {t.forms.module.desc}
          </p>
        </article>

        {/* NOZORA */}
        <article
          data-testid="form-card-nozora"
          className="terminal-frame p-6 box-glow-pink"
        >
          <div className="flex items-center justify-between">
            <h3 className="font-pixel text-[#ff0044] glow-pink text-3xl tracking-widest">{t.forms.nozora.name}</h3>
            <span className="font-pixel text-[#94a3b8] text-base">FORM 02</span>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-3 font-mono text-xs">
            <div className="bg-black/60 border border-[#ff0044]/30 p-2">
              <div className="text-[#94a3b8]">HP</div>
              <div className="text-[#ff0044] glow-pink">▮</div>
            </div>
            <div className="bg-black/60 border border-[#ff0044]/30 p-2">
              <div className="text-[#94a3b8]">FIRE</div>
              <div className="text-[#ffe600] glow-yellow">▮▮▮▮▮▮▮</div>
            </div>
            <div className="bg-black/60 border border-[#ff0044]/30 p-2">
              <div className="text-[#94a3b8]">SPEED</div>
              <div className="text-[#2bff88] glow-green">▮▮▮▮▮▮</div>
            </div>
          </div>
          <p className="mt-5 font-mono text-[#e2e8f0]/85 text-sm sm:text-base leading-relaxed">
            {t.forms.nozora.desc}
          </p>
        </article>
      </div>
    </section>
  );
};

export default FormsSection;
